import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { isEmpty } from "lodash";
import { useContextSelector } from "use-context-selector";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import AuthContext from "../../context/AuthContext";
import BetSlipContext from "../../context/BetSlipContext";
import useScrollToItem from "../../components/Scroll";
// import { AlertInfo } from "../../Utils/Alert";
const useHomeSelectionLogic = ({ object, matchOdds }) => {
  // 🔹 Context
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const profileData = useContextSelector(AuthContext, (ctx) => ctx.profileData);
  const betSlipObject = useContextSelector(
    BetSlipContext,
    (ctx) => ctx.betSlipObject,
  );
  const showBetDialog = useContextSelector(
    BetSlipContext,
    (ctx) => ctx.showBetDialog,
  );
  const setMiniBetSlip = useContextSelector(AuthContext, (ctx) => {
    return ctx.setMiniBetSlip;
  });
  const betPlace = useContextSelector(BetSlipContext, (ctx) => ctx.betPlace);
  const setBetSlipObject = useContextSelector(
    BetSlipContext,
    (ctx) => ctx.setBetSlipObject,
  );
  const setLimit = useContextSelector(BetSlipContext, (ctx) => ctx.setLimit);
  const setShowBetDialog = useContextSelector(
    BetSlipContext,
    (ctx) => ctx.setShowBetDialog,
  );

  // 🔹 State
  const [runner, setRunner] = useState([]);
  const [position, setPosition] = useState([]);
  const [localLimit, setLocalLimit] = useState({});

  const navigate = useNavigate();
  const scrollToItem = useScrollToItem("#header");

  // 🔹 Load bet limits
  useEffect(() => {
    let obj = profileData?.matchSetting?.find(
      (res) => res?.type === "betFaire" && res?.sportType === object?.gameType,
    );
    if (!isEmpty(object?.betLimitSetting)) {
      setLocalLimit(
        !isEmpty(obj)
          ? {
              ...obj,
              minAmount: object?.betLimitSetting?.minBet,
              maxAmount: object?.betLimitSetting?.maxBet,
            }
          : {},
      );
    } else if (!isEmpty(profileData)) {
      setLocalLimit(!isEmpty(obj) ? obj : { minAmount: 100, maxAmount: 50000 });
    }
  }, [profileData, object]);

  // 🔹 Fetch bet positions
  const getBetPosition = useCallback(async (item) => {
    const { status, data: response_users } = await apiGet(
      `${apiPath.betPosition}?marketId=${item?.marketId}&eventId=${item?.eventId}`,
    );
    if (status === 200 && response_users.success) {
      setPosition(response_users?.results);
      setRunner((current) =>
        response_users?.results?.betFair?.length > 0
          ? current.map((res) => {
              const obj = response_users?.results?.betFair?.find(
                (i) => i?.selectionId == res?.SelectionId,
              );
              return {
                ...res,
                position: obj ? obj?.position : 0,
                newPosition: 0,
              };
            })
          : current.map((res) => ({
              ...res,
              position: 0,
              newPosition: 0,
            })),
      );
    }
  }, []);
  // 🔹 Handle bet click

  const handelChange = (odds, type, team, item, e) => {
    if (isEmpty(user)) {
      // AlertInfo({
      //   message: "Please login to place your bet!",
      //   navigate: navigate,
      // });
      return;
    }
    if (odds?.rt > 0) {
      setShowBetDialog(true);
      let obj = {
        odds: odds?.rt,
        teamName: team,
        betType: type,
        bidPrice: "",
        playType: "home",
        newMarketId: object?.marketId,
        eventName: object?.eventName,
        status: object?.status,
        object: {
          ...item,
          ...odds,
          teamName: team,
          eventName: object?.eventName,
          eventId: object?.eventId,
          marketId: object?.marketId,
          newMarketId: object?.marketId,
        },
      };
      // setMiniBetSlip(true);
      setLimit(localLimit);
      setBetSlipObject((prev) => ({ ...prev, ...obj }));
    }
  };

  // 🔹 Update bet positions (preview mode before placing)
  const handelBetFairPositions = useCallback(
    (slipObj) => {
      let selectionsTemp = [...runner];
      if (!(betSlipObject?.bidPrice > 0)) return;

      if (slipObj?.object?.ib) {
        // Back bet
        let backProfit = (betSlipObject.odds - 1) * betSlipObject?.bidPrice;
        let backLoss = betSlipObject?.bidPrice;

        setRunner(
          selectionsTemp.map((rl) =>
            rl.SelectionId === slipObj?.object?.ri
              ? { ...rl, newPosition: Number(rl.position) + backProfit }
              : { ...rl, newPosition: Number(rl.position) - backLoss },
          ),
        );
      } else {
        // Lay bet
        let backProfit = betSlipObject?.bidPrice;
        let backLoss = (betSlipObject.odds - 1) * betSlipObject?.bidPrice;

        setRunner(
          selectionsTemp.map((rl) =>
            rl.SelectionId === slipObj?.object?.ri
              ? { ...rl, newPosition: Number(rl.position) - backLoss }
              : { ...rl, newPosition: Number(rl.position) + backProfit },
          ),
        );
      }
    },
    [runner, betSlipObject],
  );

  // 🔹 Auto-update preview when bet slip changes
  useEffect(() => {
    if (showBetDialog && betSlipObject?.playType === "home") {
      handelBetFairPositions(betSlipObject);
    }
  }, [betSlipObject, showBetDialog]);

  // 🔹 Initialize runners + fetch positions if logged in
  useEffect(() => {
    setRunner(object?.runners || []);
    if (!isEmpty(user)) {
      getBetPosition(object);
    }
  }, [user, object]);

  // 🔹 Refresh positions on bet placement success
  useEffect(() => {
    if (betPlace?.isPlaced && betPlace?.type === "matched") {
      getBetPosition(object);
    }
  }, [betPlace, object]);

  const isRtValid = useCallback((obj, limit) => {
    const { rt } = obj;
    if (rt === undefined || rt === null || rt === "" || rt === 0) return true;
    if (typeof rt === "number" && limit !== undefined) {
      return rt >= limit?.oddsLimit;
    }
    return false;
  }, []);

  const checkArrays = (arr1, arr2, limit) => {
    const combined = [...(arr1 || []), ...(arr2 || [])];
    return combined.length > 0
      ? combined.every((obj) => isRtValid(obj, limit))
      : true;
  };

  return {
    runner,
    position,
    localLimit,
    handelChange,
    getBetPosition,
    isRtValid,
    checkArrays,
    betSlipObject,
    showBetDialog,
  };
};

export default useHomeSelectionLogic;
